<app-crudbar [label]="title" (onReady)="doComReady($event,'crudbar')" [editAndSaveVisible]="true">
</app-crudbar>
<div>
  <mat-tab-group class="jk-tab-group bg-red-200" [(selectedIndex)]="wd015Index" mat-stretch-tabs="false"
    mat-align-tabs="start">
    @for(item of wd015List;track item.id){
    <mat-tab [label]="item.name" [matBadge]="item.ps1" [matBadgeDescription]="item.id"></mat-tab>
    }
  </mat-tab-group>
  <div class="w-full top-10 border-1  bg-gray-100">
    @if(masterVisible){
    <div class="top-1 border-1">
      <app-mtrki01 (onFormReady)="doFormReady($event,PageKind.master)">
      </app-mtrki01>
    </div>
    }
    @if(detailVisible){
    <div class="top-1 border-1 border-green-400">
      <app-mtrki01-detail (onFormReady)="doFormReady($event,PageKind.detail)">
      </app-mtrki01-detail>
    </div>
    }
  </div>
  <div>
